import Auth from '@Services/Auth';

export const sectionsList = [
  'abstractExpanded',
  'indextermsExpanded',
  'claimsExpanded',
  'bibliographicInfoExpanded',
  'substancesExpanded',
  'reactionsExpanded',
  'targetsExpanded',
  'hitSubstancesExpanded',
  'hitReactionsExpanded',
];

export const displayConditions = {
  abstractExpanded: (citation) => Boolean(citation.abstractText),
  indextermsExpanded: (citation) => Boolean(citation.keywords),
  claimsExpanded: (citation) => Boolean(citation.patentClaims),
  bibliographicInfoExpanded: (citation) =>
    Boolean(citation.assignees || citation.inventors || citation.priorityData || citation.patentFamily),
  substancesExpanded: (citation) => Boolean(citation.substancesCount),
  reactionsExpanded: (citation) => {
    const { reactionsCount } = citation;
    return Boolean(reactionsCount) && !Auth.isRMCLicense();
  },
  targetsExpanded: (citation) => {
    const { targetsCount } = citation;
    return Boolean(targetsCount) && !Auth.isClassicLicense();
  },
  hitSubstancesExpanded: (citation) => Boolean(citation.substancesHitCount),
  hitReactionsExpanded: (citation) => {
    const { reactionsHitCount } = citation;
    return Boolean(reactionsHitCount) && !Auth.isRMCLicense();
  },
};

export const getFirstAvailableSection = (citation) => sectionsList.find((section) => displayConditions[section](citation));
